import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteAll: {
    id: 'app.components.PhotosphereContent.deleteAll',
    defaultMessage: 'Excluir todas as fotos',
  },
});

